<template>
  <div class="type-add">
    <el-dialog
      title="新增值日类型"
      :visible="dialogVisible"
      @close="dialogClose"
      :close-on-click-modal="false"
      width="600px"
      center
    >
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="类型:" prop="typeName">
                <el-input
                  v-model="ruleForm.typeName"
                  placeholder="请输入值日类型"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="是否首页展示:" required>
                <el-select v-model="ruleForm.status" placeholder="请选择">
                  <el-option
                    v-for="item in isShowList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="值班范围:" required>
                <el-select v-model="ruleForm.dutyArea" placeholder="请选择">
                  <el-option
                    v-for="item in dutyAreaList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="显示顺序:" prop="showOrder">
                <el-input
                  v-model="ruleForm.showOrder"
                  placeholder="请输入显示顺序"
                  type="number"
                ></el-input> </el-form-item
            ></el-col>
          </el-form-item>
          <el-form-item
            v-for="(item, index) in ruleForm.periodList"
            :key="index"
            :label="'值班时间段' + '(' + (index + 1) + '):'"
            required
          >
            <el-time-picker
              is-range
              v-model="item.time"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              format="HH:mm"
              selectableRange="00:00:00 - 23:59:00"
              :default-value="[
                new Date(0).setHours(1),
                new Date(0).setHours(23),
              ]"
            >
            </el-time-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addTime">添加时间段</el-button>
        <el-button type="danger" @click="delTime">删除时间段</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    dutyAreaList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isShowList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  inject: ["refresh"],
  created() {},
  data() {
    return {
      ruleForm: {
        typeName: "", // 类型名称
        status: "", // 是否首页展示
        dutyArea: "", // 值班范围
        showOrder: "", // 显示顺序
        periodList: [{ time: null }], // 值班时间列表
      },
      rules: {
        typeName: [
          { required: true, message: "请输入值日类型", trigger: "blur" },
        ],
        showOrder: [
          { required: true, message: "请输入显示顺序", trigger: "blur" },
        ]
      },
    };
  },
  methods: {
    addTime() {
      this.ruleForm.periodList.push({
        time: null,
      });
    },
    delTime() {
      if (this.ruleForm.periodList.length === 1)
        return this.$message.warning("至少保留一个时间段");
      this.ruleForm.periodList.pop();
    },
    // time字符串转为date格式日期数组
    parseTimeString(timeString) {
      // 检查字符串是否为有效格式
      const timeRegex = /^(\d{2})(\d{2})-(\d{2})(\d{2})$/;
      const match = timeString.match(timeRegex);

      if (!match) {
        throw new Error("无效的时间格式");
      }

      // 提取小时和分钟部分
      const [, startHour, startMinute, endHour, endMinute] = match;

      // 创建日期对象
      const startDate = new Date();
      startDate.setHours(Number(startHour));
      startDate.setMinutes(Number(startMinute));

      const endDate = new Date();
      endDate.setHours(Number(endHour));
      endDate.setMinutes(Number(endMinute));

      // 返回包含两个日期的数组
      return [startDate, endDate];
    },
    dialogClose() {
      this.$emit("update:dialogVisible", false);
    },
    // 时间段补0
    formatTime(date) {
      return `${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${
        date.getMinutes() < 10 ? "0" : ""
      }${date.getMinutes()}`;
    },
    confirm(formName) {
      // 验证表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { typeName, status, dutyArea, periodList, showOrder } = this.ruleForm;
          // 时间段为空
          if (!periodList[periodList.length - 1].time)
            return this.$message.warning("请选择时间段的时间");
          let timePeriod = [];
          periodList.forEach((item) => {
            timePeriod.push({
              startTime: this.formatTime(new Date(item.time[0])),
              endTime: this.formatTime(new Date(item.time[1])),
            });
          });
          let submit = {
            dutyType: {
              schoolId: this.user.schoolId,
              typeName,
              status,
              dutyArea,
              showOrder
            },
            periodList: timePeriod,
          };
          // 新增值班类型
          this.post(this.$url.insertDutyType, submit)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("新增成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error("新增失败");
              }
            })
            .catch((err) => {
              this.$message.error("新增失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./type-add.scss";
</style>
